import { RefObject, useCallback } from 'react';

type Props = {
  containerRef?: RefObject<HTMLDivElement> | null;
};
export type ScrollIntoViewProps = {
  scrollTargetQuerySelector: string;
  scrollDelay?: number;
  scrollBehavior?: ScrollBehavior;
  scrollBlock?: ScrollLogicalPosition;
};
export const useScrollIntoView = ({ containerRef }: Props) => {
  const scrollTo = useCallback(
    ({ scrollTargetQuerySelector, scrollDelay, scrollBehavior, scrollBlock }: ScrollIntoViewProps) => {
      setTimeout(() => {
        const container = containerRef?.current || document;
        const selected = container.querySelector(scrollTargetQuerySelector);
        selected?.scrollIntoView({ behavior: scrollBehavior || 'auto', block: scrollBlock || 'start' });
      }, scrollDelay || 0);
    },
    [containerRef]
  );

  return {
    scrollTo,
  };
};
